import { useAuthStore } from '@/stores/auth.ts';
export class ModuleService {
    can(moduleType) {
        if (!this._companyCheck()) {
            return false;
        }
        const module = this._getModule(moduleType);
        return Boolean(module && module.is_available_for_usage);
    }
    owned(moduleType) {
        if (!this._companyCheck()) {
            return false;
        }
        const module = this._getModule(moduleType);
        return Boolean(module && module.owned);
    }
    enabled(moduleType) {
        if (!this._companyCheck()) {
            return false;
        }
        const module = this._getModule(moduleType);
        return Boolean(module && module.enabled);
    }
    _companyCheck() {
        var _a, _b;
        if (!this.getAuthStore().user) {
            return false;
        }
        return (_b = (_a = this.getAuthStore().user) === null || _a === void 0 ? void 0 : _a.activeCompany) === null || _b === void 0 ? void 0 : _b.enabled_modules;
    }
    _getModule(type) {
        var _a, _b;
        return (_b = (_a = this.getAuthStore().user) === null || _a === void 0 ? void 0 : _a.activeCompany) === null || _b === void 0 ? void 0 : _b.enabled_modules.find(m => m.type === type);
    }
    getAuthStore() {
        return useAuthStore();
    }
}
export const moduleService = new ModuleService();
